<template>
    <div v-if="props.lastWXData" class="col-md-8 m-auto p-2">
        <div class="row align-items-center mb-1">
            <div class="col-md-3 text-center p-2 bg-warning bg-gradient rounded-1 border border-dark"
                style="height: 130px; display: grid; align-content: center;">
                <div class="text-dark fs-6"><small>{{t('Weather Data: Station:')}}</small></div>
                <div class="text-dark fs-4 fw-bold">{{
                    props.lastWXData.sourceCallsign }}</div>
            </div>
            <div class="col-md-3 text-center p-2 bg-warning bg-gradient rounded-1 border border-dark"
                style="height: 130px; display: grid; align-content: center;">
                <div class="text-dark fs-5 fw-bold">{{
                    formatedRTDateTime(props.lastWXData.receivedTime).date }}</div>
                <div class="text-dark fs-6 fw-bold">{{
                    formatedRTDateTime(props.lastWXData.receivedTime).time }} UTC</div>
                <div class="text-dark fs-5 fw-bold">- {{
                    formatedRTDateTime(props.lastWXData.receivedTime).diff }} min.</div>
            </div>
            <div class="col-md-3 text-center p-2 bg-warning bg-gradient rounded-1 border border-dark"
                :class="{'opacity-50':(!props.lastWXData.wx.pressure)}"
                style="height: 130px; display: grid; align-content: center;">
                <div class="text-dark fs-6"><small>{{t('Relative Pressure:')}}</small></div>
                <div class="text-dark fs-4 fw-bold text-nowrap">
                    {{ props.lastWXData.wx.pressure ? props.lastWXData.wx.pressure : '----.-' }}<span
                        class="fs-6">&nbsp;hPa</span></div>
                <!-- <div class="text-dark fs-3 fw-bold position-absolute bottom-0 end-100 translate-middle">[zredudkowane do poziomu morza]</div> -->
            </div>
            <div class="position-relative col-md-3 text-center p-2 bg-warning bg-gradient rounded-1 border border-dark"
                :class="{'opacity-50':(!props.lastWXData.wx.temp)}"
                style="height: 130px; display: grid; align-content: center;">
                <div class="text-dark fs-6"><small>{{t('Temperature:')}}</small></div>
                <div class="text-dark fs-3 fw-bold">
                    {{ props.lastWXData.wx.temp ? props.lastWXData.wx.temp : '--.-' }}<span class="fs-6">&nbsp;°C</span>
                </div>
            </div>
        </div>
        <!-- <div class="row align-items-center bg-warning bg-gradient rounded-1 mb-1">
            <div class="col-md-12 text-center p-1">
                &nbsp;
            </div>
        </div> -->
        <div class="row align-items-center text-center mb-1">
            <div class="col-md-5 p-2 rounded-1 bg-warning bg-gradient border border-dark"
                :class="{'opacity-50':(!props.lastWXData.wx.wind_speed && !props.lastWXData.wx.wind_gust)}"
                style="height: 150px;">
                <div class="d-flex text-dark fs-6"><small>{{t('Wind:')}}</small></div>
                <div class="">
                    <span class="text-dark fs-6"><small>{{t('Speed:')}}&nbsp;&nbsp;</small></span>
                    <span class="text-dark fs-2 fw-bold">{{ props.lastWXData.wx.wind_speed ?
                        props.lastWXData.wx.wind_speed : '--.-' }}<span class="fs-6">&nbsp;km/h</span></span>
                </div>
                <div class="">
                    <span class="text-dark fs-6"><small>{{t('Gust:')}}&nbsp;&nbsp;</small></span>
                    <span class="text-dark fs-2 fw-bold">{{ props.lastWXData.wx.wind_gust ?
                        props.lastWXData.wx.wind_gust : '--.-' }}<span class="fs-6">&nbsp;km/h</span></span>
                </div>
            </div>
            <div class="col-md-4 p-2 rounded-1 bg-warning bg-gradient border border-dark"
                :class="{'opacity-50':(!props.lastWXData.wx.wind_direction)}"
                style="height: 150px; display: grid; align-content: center;">
                <div class="text-dark fs-6 pb-2"><small>{{t('Wind Direction:')}}</small></div>
                <div class="row align-items-center">
                    <div class="col-6">
                        <WindDirectionSVG :wdir="props.lastWXData.wx.wind_direction" v-if="props.lastWXData.wx.wind_direction" />
                    </div>
                    <div class="col-6 text-dark fs-1 fw-bold px-2">
                        {{ props.lastWXData.wx.wind_direction ?
                        props.lastWXData.wx.wind_direction : '---' }}&nbsp;°
                    </div>
                </div>
            </div>

            <div class="col-md-3 p-2 rounded-1 bg-warning bg-gradient border border-dark"
                :class="{'opacity-50':(!props.lastWXData.wx.humidity)}"
                style="height: 150px; display: grid; align-content: center;">
                <div class="text-dark fs-6"><small>{{t('Humidity:')}}</small></div>
                <div class="text-dark fs-1 fw-bold">{{ props.lastWXData.wx.humidity ? props.lastWXData.wx.humidity :
                    '---' }}<span class="fs-6">&nbsp;%</span></div>
            </div>
        </div>
        <!-- <div class="row align-items-center bg-warning rounded-1 bg-gradient ">
            <div class="col-md-12 text-center p-1">
                <div class="text-dark fs-6">-----</div>
            </div>
        </div> -->
        <div class="row bg-warning bg-gradient rounded-1 mb-1"
            :class="{'opacity-50':(!props.lastWXData.wx.rain_1h && !props.lastWXData.wx.rain_24h && !props.lastWXData.wx.rain_midnight)}">
            <div class="row-md-12 text-dark px-2 fs-6"><small>{{t('Rain:')}}</small></div>
            <div class="d-flex justify-content-center text-dark col-md-4 align-items-center" style="height: 50px;">
                <div class="fs-6"><small>{{t('Last Hour:')}}&nbsp;</small></div>
                <div class="fs-6 fw-bold">{{ props.lastWXData.wx.rain_1h ? props.lastWXData.wx.rain_1h : '-.--' }} mm
                </div>
            </div>
            <div class="d-flex justify-content-center text-dark col-md-4 align-items-center" style="height: 50px;">
                <div class="fs-6"><small>{{t('Last 24 Hours:')}}&nbsp;</small></div>
                <div class="fs-6 fw-bold">{{ props.lastWXData.wx.rain_24h ? props.lastWXData.wx.rain_24h : '-.--' }} mm
                </div>
            </div>
            <div class="d-flex justify-content-center text-dark col-md-4 align-items-center" style="height: 50px;">
                <div class="fs-6"><small>{{t('From Midnight:')}}&nbsp;</small></div>
                <div class="fs-6 fw-bold">{{ props.lastWXData.wx.rain_midnight ? props.lastWXData.wx.rain_midnight :
                    '-.--' }} mm</div>
            </div>
        </div>
    </div>
</template>

<!-- ######################################################################################################## -->

<script setup>
import { defineProps } from 'vue'
import { formatedRTDateTime } from '../js/tmlf.js'
import { useI18n } from 'vue-i18n'
import WindDirectionSVG from './WindDirectionSVG.vue';

const { t } = useI18n()

const props = defineProps({
    lastWXData: Object,
 })

</script>

<!-- ######################################################################################################## -->

<i18n>
    {
      "pl": {
        "Weather Data: Station:": "Dane Pogodowe Stacji:",
        "Relative Pressure:": "Ciśnienie względne:",
        "Temperature:": "Temperatura:",
        "Wind:": "Wiatr:",
        "Speed:": "Prędkość:",
        "Gust:": "Porywy:",
        "Wind Direction:": "Kierunek Wiatru:",
        "Humidity:": "Wilgotność:",
        "Rain:": "Opady:",
        "Last Hour:": "Ost. godz.:",
        "Last 24 Hours:": "Ost. 24 godz.:",
        "From Midnight:": "Od północy:",
      }
    }
</i18n>
